import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { LUCIDE_ICONS } from '../../shared/ui/lucide-icon/lucide-icons.token';
import {
  LucideMenu,
  LucideX,
  LucideTruck,
  LucidePackage,
  LucideWrench,
  LucideFileText,
  LucideBuilding2,
  LucideCircleCheck,
  LucideTriangleAlert,
  LucideLogIn,
  LucideUser,
  LucideLayoutDashboard,
  LucideUsers,
  LucideChevronLeft,
  LucideChevronRight,
  LucideScanLine,
  LucidePackageSearch,
  LucideMap,
  LucideDollarSign,
  LucideUserRound,
  LucideBriefcase,
  LucideArrowRightLeft,
  LucideArrowRight,
  LucideArrowLeft,
  LucideSearch,
  LucidePercent,
  LucideThermometer,
  LucideSquare,
  LucideCalendar,
  LucideCircleX,
  LucideChevronDown,
  LucideCheck,
  LucidePlus,
  LucideCirclePlus,
  LucideTrash2,
  LucideClock,
  LucideMoon,
  LucideSun,
  LucideGrid2X2,
  LucideLoaderCircle,
  LucideRocket,
  LucideHeart,
  LucideSettings,
  LucideMinus,
  LucideChevronUp,
  LucideLogOut,
  LucideLayoutGrid,
  LucideCloud,
  LucideZap,
  LucideHeadphones,
  LucideAppWindow,
  LucideChevronsLeft,
  LucideChevronsRight,
  LucideBell,
  LucideFastForward,
  LucideSkipForward,
  LucideCircleAlert,
  LucideChartBar,
  LucideUserCheck,
  LucideFuel,
  LucideActivity,
  LucideArchive,
  LucideCircleSlash,
  LucideLoader,
  LucideGem,
  LucideTable,
  LucideList,
  LucideSquarePen,
  LucideMapPin,
  LucideChevronsUpDown,
  LucideNotebookPen,
  LucideSave,
  LucideCircleArrowUp,
  LucideCircleArrowDown,
  LucideUploadCloud,
  LucideBuilding,
  LucideSend,
  LucideSparkles,
  LucideBot,
  LucideMic,
  LucideGripVertical,
  LucideArrowUp,
  LucideArrowDown,
  LucideArrowUpDown,
  LucideCheckCheck,
  LucidePencil,
  LucideCircle,
  LucideFileSignature,
  LucideEye,
  LucideSlidersHorizontal,
  LucideContainer,
  LucideMapPinPlus,
  LucideMilestone,
  LucideSnowflake,
  LucideClipboard,
  LucideTally5,
  LucideBanknote,
  LucideSquareArrowUpRight,
  LucideReceipt,
  LucideRadar,
  LucideHash,
  LucideWeight,
  LucideCircleHelp,
  LucideRotateCcw,
  LucideDownload,
  LucideRefreshCcw,
  LucideBellRing,
  LucideUpload,
  LucideImage,
  LucidePaperclip,
  LucideExternalLink,
  LucideNavigation,
  LucideCompass,
  LucideRoute,
  LucidePhone,
  LucideMail,
  LucideMessageCircle,
  LucideMessageSquare,
  LucideMessageSquareText,
  LucideRadio,
  LucideTrendingUp,
  LucideEyeOff,
  LucideCopy,
  LucideShare,
  LucideEllipsisVertical,
  LucideEllipsis,
  LucideInfo,
  LucideRefreshCw,
  LucideMapPinCheck,
  LucidePackageCheck,
  LucidePackageOpen,
  LucideFileCheck,
  LucideLoader2,
  LucideShieldCheck,
  LucideSearchX,
  LucideGlobe,
  LucideUserPlus,
  LucideShieldAlert,
  LucideKeyRound,
  LucideKey,
  LucideCircleDollarSign,
  LucideFilter,
  LucideGauge,
  LucideCalendarClock,
  LucidePalette,
  LucideFileWarning,
  LucideCar,
  LucideScanBarcode,
  LucideMaximize2,
  LucideUserCog,
  LucideUserMinus,
  LucideUserX,
  LucideTag,
  LucideShield,
  LucideMailPlus,
  LucideFilePen,
  LucideCircleCheckBig,
  LucideHandshake,
  LucideUserCircle,
  LucideFoldVertical,
  LucideUnfoldVertical,
  LucideLayers,
  LucideBook,
  LucideStar,
  LucideLandmark,
  LucideBan,
  LucideSmartphone,
  LucideMonitor,
  LucideFolderOpen,
  LucideZoomIn,
  LucideCreditCard,
  LucideBadgeDollarSign,
  LucideMoreVertical,
  LucideHistory,
  LucideWarehouse,
  LucideLink,
  LucideEdit,
  LucideFilePlus,
  LucideCheckCircle,
  LucideCheckCircle2,
  LucideAlertCircle,
  LucideAlertTriangle,
  LucideXCircle,
  LucideMinusCircle,
  LucidePartyPopper,
  LucideLock,
  LucideHourglass,
  LucideThumbsUp,
  LucideFileX,
  LucidePackagePlus,
  LucidePackageMinus,
  LucideClipboardCheck,
  LucideAnchor,
  LucideArrowRightFromLine,
  LucideMoveRight,
  LucideMapPinOff,
  LucideBarChart3,
  LucideMessageSquareWarning,
  LucideParkingSquare,
  LucideTimer,
  LucideClockAlert,
  LucideFiles,
  LucideDatabase,
  LucidePlay,
  LucideFileSpreadsheet,
  LucideLayoutList,
  LucideIdCard,
  LucideWallet,
  // S3 notifications
  LucideHand,
  LucideInbox,
  LucideUndo2,
  LucideBellOff,
  LucideLocateFixed, // S6 live tracking
  LucideLanguages, // S4 chat translation
  LucideBookmark,
  LucideFlag,
  LucidePin,
  LucidePinOff,
  LucideShare2,
  LucideStickyNote,
  LucideGitFork,
  LucideSplit,
  LucideMerge,
  LucideTrendingDown,
  LucideArrowUpRight,
  LucideFlame,
} from '@lucide/angular';

/**
 * Build a flat registry: { 'kebab-name': iconData, 'PascalName': iconData, ... }
 * This supports lookup by both PascalCase names (used in old templates)
 * and kebab-case names.
 */
function buildIconRegistry(
  icons: Array<{ icon: { name: string; node: any; aliases?: string[] } }>
): Record<string, any> {
  const registry: Record<string, any> = {};
  for (const iconComponent of icons) {
    const data = iconComponent.icon;
    // Register by kebab-case name
    registry[data.name] = data.node;
    // Register by PascalCase name (e.g. "AlertTriangle")
    const pascal = data.name
      .split('-')
      .map((w: string) => w.charAt(0).toUpperCase() + w.slice(1))
      .join('');
    registry[pascal] = data.node;
    // Also register lowercase
    registry[data.name.toLowerCase().replace(/-/g, '')] = data.node;
    // Register aliases
    for (const alias of data.aliases ?? []) {
      registry[alias] = data.node;
      const aliasPascal = alias
        .split('-')
        .map((w: string) => w.charAt(0).toUpperCase() + w.slice(1))
        .join('');
      registry[aliasPascal] = data.node;
    }
  }
  return registry;
}

const ALL_ICONS = [
  LucideMenu,
  LucideX,
  LucideTruck,
  LucidePackage,
  LucideWrench,
  LucideFileText,
  LucideBuilding2,
  LucideCircleCheck,
  LucideTriangleAlert,
  LucideLogIn,
  LucideUser,
  LucideLayoutDashboard,
  LucideUsers,
  LucideChevronLeft,
  LucideChevronRight,
  LucideScanLine,
  LucidePackageSearch,
  LucideMap,
  LucideDollarSign,
  LucideUserRound,
  LucideBriefcase,
  LucideArrowRightLeft,
  LucideArrowRight,
  LucideArrowLeft,
  LucideSearch,
  LucidePercent,
  LucideThermometer,
  LucideSquare,
  LucideCalendar,
  LucideCircleX,
  LucideChevronDown,
  LucideCheck,
  LucidePlus,
  LucideCirclePlus,
  LucideTrash2,
  LucideClock,
  LucideMoon,
  LucideSun,
  LucideGrid2X2,
  LucideLoaderCircle,
  LucideRocket,
  LucideHeart,
  LucideSettings,
  LucideMinus,
  LucideChevronUp,
  LucideLogOut,
  LucideLayoutGrid,
  LucideAppWindow,
  LucideChevronsLeft,
  LucideChevronsRight,
  LucideBell,
  LucideCircleAlert,
  LucideChartBar,
  LucideUserCheck,
  LucideFuel,
  LucideActivity,
  LucideArchive,
  LucideCircleSlash,
  LucideLoader,
  LucideGem,
  LucideTable,
  LucideList,
  LucideSquarePen,
  LucideMapPin,
  LucideChevronsUpDown,
  LucideNotebookPen,
  LucideSave,
  LucideCircleArrowUp,
  LucideCircleArrowDown,
  LucideUploadCloud,
  LucideBuilding,
  LucideSend,
  LucideSparkles,
  LucideBot,
  LucideMic,
  LucideGripVertical,
  LucideArrowUp,
  LucideArrowDown,
  LucideArrowUpDown,
  LucideCheckCheck,
  LucidePencil,
  LucideCircle,
  LucideFileSignature,
  LucideEye,
  LucideSlidersHorizontal,
  LucideContainer,
  LucideMapPinPlus,
  LucideMilestone,
  LucideSnowflake,
  LucideClipboard,
  LucideTally5,
  LucideBanknote,
  LucideSquareArrowUpRight,
  LucideReceipt,
  LucideRadar,
  LucideHash,
  LucideWeight,
  LucideCircleHelp,
  LucideRotateCcw,
  LucideDownload,
  LucideRefreshCcw,
  LucideBellRing,
  LucideUpload,
  LucideImage,
  LucidePaperclip,
  LucideExternalLink,
  LucideNavigation,
  LucideCompass,
  LucideRoute,
  LucidePhone,
  LucideMail,
  LucideMessageCircle,
  LucideMessageSquare,
  LucideMessageSquareText,
  LucideRadio,
  LucideTrendingUp,
  LucideEyeOff,
  LucideCopy,
  LucideShare,
  LucideEllipsisVertical,
  LucideEllipsis,
  LucideInfo,
  LucideRefreshCw,
  LucideMapPinCheck,
  LucidePackageCheck,
  LucidePackageOpen,
  LucideFileCheck,
  LucideLoader2,
  LucideShieldCheck,
  LucideSearchX,
  LucideGlobe,
  LucideUserPlus,
  LucideShieldAlert,
  LucideKeyRound,
  LucideKey,
  LucideCircleDollarSign,
  LucideFilter,
  LucideGauge,
  LucideCalendarClock,
  LucidePalette,
  LucideFileWarning,
  LucideCar,
  LucideScanBarcode,
  LucideMaximize2,
  LucideUserCog,
  LucideUserMinus,
  LucideUserX,
  LucideTag,
  LucideShield,
  LucideMailPlus,
  LucideFilePen,
  LucideCircleCheckBig,
  LucideHandshake,
  LucideUserCircle,
  LucideFoldVertical,
  LucideUnfoldVertical,
  LucideLayers,
  LucideBook,
  LucideStar,
  LucideLandmark,
  LucideBan,
  LucideSmartphone,
  LucideMonitor,
  LucideFolderOpen,
  LucideZoomIn,
  LucideCreditCard,
  LucideBadgeDollarSign,
  LucideMoreVertical,
  LucideCloud,
  LucideZap,
  LucideHeadphones,
  LucideHistory,
  LucideWarehouse,
  LucideLink,
  LucideEdit,
  LucideFilePlus,
  LucideCheckCircle,
  LucideCheckCircle2,
  LucideAlertCircle,
  LucideAlertTriangle,
  LucideXCircle,
  LucideMinusCircle,
  LucidePartyPopper,
  LucideLock,
  LucideHourglass,
  LucideThumbsUp,
  LucideFileX,
  LucidePackagePlus,
  LucidePackageMinus,
  LucideClipboardCheck,
  LucideAnchor,
  LucideArrowRightFromLine,
  LucideMoveRight,
  LucideMapPinOff,
  LucideBarChart3,
  LucideMessageSquareWarning,
  LucideParkingSquare,
  LucideTimer,
  LucideClockAlert,
  LucideFiles,
  LucideDatabase,
  LucidePlay,
  LucideChevronsUpDown,
  LucideFileSpreadsheet,
  LucideFastForward,
  LucideSkipForward,
  LucideLayoutList,
  LucideIdCard,
  LucideWallet,
  // S3 notifications
  LucideHand,
  LucideInbox,
  LucideUndo2,
  LucideBellOff,
  LucideLocateFixed, // S6 live tracking
  LucideLanguages, // S4 chat translation
  LucideBookmark,
  LucideFlag,
  LucidePin,
  LucidePinOff,
  LucideShare2,
  LucideStickyNote,
  LucideGitFork,
  LucideSplit,
  LucideMerge,
  LucideTrendingDown,
  LucideArrowUpRight,
  LucideFlame,
] as any[];

export function provideIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: LUCIDE_ICONS,
      useValue: buildIconRegistry(ALL_ICONS),
    },
  ]);
}
